import React, { Fragment } from 'react';
import { Button, ButtonSet, Box, Dialog, DialogContent, DialogHeader, DialogBody, DialogFooter } from '@indeed/ifl-components';
import { themed } from '@indeed/ifl-css';
// `<DialogBody>` with default IFL text style
const StyledDialogBody = themed(DialogBody)(() => ({
    variant: 'text.level3',
    color: 'foreground'
}));
const Modal = ({ icon, title, description, buttonText, secondButtonText, cancelText, buttonLoading, secondButtonLoading, buttonDisabled, secondButtonDisabled, cancelButtonDisabled, onClickButton, onClickSecondButton, onClickCancel, isOpen = true, onClose = () => { } }) => {
    return (React.createElement(Dialog, { size: 'sm', type: "alertdialog", open: isOpen, onOpenChange: (open) => {
            if (!open)
                onClose();
        } },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, { contentBefore: icon && React.createElement(Box, null, icon) }, typeof title === 'string' ? (title) : (React.createElement(React.Fragment, null, title.map((line, index) => (React.createElement(Fragment, { key: index },
                line,
                index < title.length - 1 && React.createElement("br", null))))))),
            description && React.createElement(StyledDialogBody, null, description),
            React.createElement(DialogFooter, null,
                React.createElement(ButtonSet, { orientation: "vertical" },
                    cancelText && (React.createElement(Button, { size: "md", full: true, onClick: onClickCancel, variant: "tertiary", disabled: cancelButtonDisabled }, cancelText)),
                    secondButtonText && (React.createElement(Button, { full: true, variant: "secondary", size: "md", onClick: onClickSecondButton, loading: secondButtonLoading, disabled: secondButtonDisabled }, secondButtonText)),
                    React.createElement(Button, { size: "md", full: true, variant: "primary", onClick: onClickButton, loading: buttonLoading, disabled: buttonDisabled }, buttonText))))));
};
export default Modal;
